import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import headerTitleImg from '../../assets/capo-profile-img.png'

import './style.scss';

const PageHeader = ({ siteTitle }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrolled && window.pageYOffset > 30) {
        setScrolled(true);
      } else if (scrolled && window.pageYOffset <= 30) {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <header className={scrolled ? "page-header-wrapper scrolled" : "page-header-wrapper"}>
      <div className="page-header">
        <div className="front-section">
          <Link className="link" to="/">
            <div className="front-section-img-title-wrapper">
              <img className="front-section-img" src={headerTitleImg} />
              <div className="front-section-title">
                {siteTitle}
              </div>
            </div>
          </Link>
        </div>
        <div className="trailing-section">
          <Link className="link" to="/about">
            about
          </Link>
          <Link className="link" to="/posts">
            posts
          </Link>
        </div>
      </div>
    </header>
  );
};

PageHeader.propTypes = {
  siteTitle: PropTypes.string,
};

PageHeader.defaultProps = {
  siteTitle: ``,
};

export default PageHeader;